import { isE2E, isE2ENew } from '@/utils/userSettings'

// Values exposed to the InMoment intercept script so it can configure the
// survey. Kept as constants to avoid magic strings and to document the
// contract agreed with the InMoment team.
export const SURVEY_FLOW_TYPES = {
  E2E: 'e2e',
  MDM: 'mdm'
}

export const SURVEY_DEVICE_TYPES = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
}

const getFlowType = () =>
  isE2E() || isE2ENew() ? SURVEY_FLOW_TYPES.E2E : SURVEY_FLOW_TYPES.MDM

// Mirrors the device detection already used in App.js (created hook).
const getDeviceType = () =>
  /Mobile/i.test(navigator.userAgent)
    ? SURVEY_DEVICE_TYPES.MOBILE
    : SURVEY_DEVICE_TYPES.DESKTOP

/**
 * Exposes the survey configuration on the global scope under
 * `window.selfcareSurvey` so the InMoment intercept script can read it.
 *
 * Must be called BEFORE the InMoment script is injected/executed so the
 * variables are available when the intercept runs.
 *
 * @returns {{ flowType: string, deviceType: string }}
 */
export const exposeSurveyConfig = () => {
  window.selfcareSurvey = {
    flowType: getFlowType(),
    deviceType: getDeviceType()
  }
  return window.selfcareSurvey
}
